import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthGuard } from './auth.guard'; // Correct
// import { MessageService } from 'primeng/api';
// import { ProductService } from './pages/service/product.service';

import { Inject } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private authService: AuthGuard,
    private router: Router,
    // private messageService: MessageService
   
  ) {}
private hasRedirected = false;

canActivate(): boolean {
  if (this.authService.isLoggedIn()) {
    if (!this.hasRedirected) {
      this.hasRedirected = true;
      console.log('User is already logged in, redirecting to dashboard...');
       setTimeout(() => {
    this.router.navigate(['/Orders1'], { replaceUrl: true });

    }, 10);
    }
    return false;
  }

  return true;
}

}

// import { Injectable } from '@angular/core';
// import { CanActivate, Router } from '@angular/router';
// import { AuthGuard } from './auth.guard'; // Correct
// // import { MessageService } from 'primeng/api';
// // import { ProductService } from './pages/service/product.service';

// import { Inject } from '@angular/core';
// @Injectable({
//   providedIn: 'root'
// })
// export class LoginGuard implements CanActivate {
//   constructor(
//     private authService: AuthGuard,
//     private router: Router,
//     // private messageService: MessageService
   
//   ) {}

//   canActivate(): boolean {
//     if (this.authService.isLoggedIn()) {
//       // this.messageService.add({
//       //   severity: 'info',
//       //   summary: 'Already Logged In',
//       //   detail: 'You are already logged in.',
//       //   life: 3000
//       // });
//           console.log('User is already logged in, redirecting to dashboard.');
//       this.router.navigate(['/Orders']);
//       return false;
//     }
//     return true;
//   }
// }